import React, { useState } from 'react';
import { Modal, Form, Button } from 'semantic-ui-react';

const RejectionModal = ({ open, onClose, onSubmit, isSubmitting }) => {
    const [reason, setReason] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = () => {
        if (!reason.trim()) {
            setError('Please provide a reason for rejection');
            return;
        }
        onSubmit(reason);
        setReason('');
        setError('');
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Modal.Header>Provide Rejection Reason</Modal.Header>
            <Modal.Content>
                <Form>
                    <Form.TextArea
                        label="Reason for Rejection"
                        placeholder="Please explain why this request is being rejected..."
                        value={reason}
                        onChange={(e) => {
                            setReason(e.target.value);
                            if (error) setError('');
                        }}
                        error={error ? { content: error } : null}
                        disabled={isSubmitting}
                    />
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button
                    onClick={onClose}
                    disabled={isSubmitting}
                >
                    Cancel
                </Button>
                <Button
                    negative
                    onClick={handleSubmit}
                    loading={isSubmitting}
                    disabled={isSubmitting}
                >
                    Submit Rejection
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export default RejectionModal;